import styled from 'styled-components';

export const Navvo= styled.nav
.attrs(() => ({
  className: 'white',
}))`
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px rgba(18, 32, 59, 0.05);
`;

